import { action, extendObservable } from 'mobx';
import FetchService from '../../../../core/services/FetchService';
import { formatValueByIndicator, formatIndicator } from './utils';
import { round } from 'lodash';

class ContentHistoryService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      indicator: null,
      company: null,
      data: [],
    });
  }

  getFormattedValue = (indicator, value) => formatValueByIndicator(indicator, value);

  getFormattedIndicator = (indicator) => formatIndicator(indicator);

  closeDialog = action(() => {
    this.isOpen = false;
    this.indicator = null;
  });

  openDialog = action((indicator, company) => {
    this.isOpen = true;
    this.indicator = indicator;
    this.company = company;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/kpis/content/indicators/${this.indicator}/history`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.data = this.fetch.data.map((item) => ({
            ...item,
            value: round(item.value, 2),
          }));
        } else {
          this.data = [];
        }
      });
  });
}

const contentHistoryService = new ContentHistoryService();
export default contentHistoryService;
